module.exports = __webpack_public_path__ + "static/media/live27_04_2018.599f003d.jpg";